import React from "react";

/**
 * Hinweis, dass das geplante Gericht inzwischen eine neuere Version hat als
 * die beim Planen verwendete (gespeicherte) Version.
 */
export const DishVersionWarning = ({ outdated }: { outdated: boolean }) => {
  if (!outdated) {
    return null;
  }
  return (
    <div
      className="rounded-card border border-gold bg-gold/10 text-ink text-xs px-3 py-2"
      data-cy="dish-version-warning"
    >
      Dieses Gericht wurde inzwischen geändert. Die hier gezeigten Angaben
      können von der aktuellen Version abweichen.
    </div>
  );
};
